import * as React from "react";

const ArrowFrontIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
		<path d="M139.8 331.02c-75.75.11-3.95.09-79.7.2s114.82-114.53 152.35-151.96c1.93-1.92 1.94-2.82 0-4.75C174.33 136.5 108.29 62.4 70.05 24.13l69.93-1.14s-69.93 1.14 0 0c50.62 50.6 101.29 101.16 151.82 151.85l-152 156.18" />
	</svg>
);

export default ArrowFrontIcon;
